import { GPagination, useGPagination } from '~/presentation/common';
import { BlockStack, Box, Card, Text } from '@shopify/polaris';
import { CGTemplatePairItem } from './CGTemplatePairItem';
import { useCGTemplateContext } from '../../../contexts';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';

export const CGTemplatePair = forwardRef<HTMLDivElement>((_, ref) => {
  const { t } = useTranslation();
  const { campaignGroupCampaigns } = useCGTemplateContext();
  const {
    currentPage,
    totalPages,
    paginatedData: campaigns,
    handlePageChange,
  } = useGPagination({
    data: campaignGroupCampaigns || [],
    itemsPerPage: 4,
  });

  return (
    <div ref={ref}>
      <Card padding={'400'}>
        <BlockStack gap={'400'}>
          <Text as="h3" variant="headingMd">
            {t('Templates listing')}
          </Text>
          <BlockStack gap={'400'}>
            {campaigns?.map((item) => (
              <CGTemplatePairItem data={item} key={item.id} />
            ))}
          </BlockStack>
          {totalPages > 1 && (
            <Box padding="400" paddingBlockStart="0">
              <GPagination
                currentPage={currentPage}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </Box>
          )}
        </BlockStack>
      </Card>
    </div>
  );
});

CGTemplatePair.displayName = 'CGTemplatePair';
